import React, { memo, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './InputSearch.module.scss';
import SearchIcon from 'assets/svg/mobile_search_black.svg';
import CloseIcon from 'assets/svg/mobile_close.svg';

export type Props = {
    onChangeValue: (value: string) => void;
    onKeyDown?: (event: any) => void;
    placeholder: string;
    inputContainerClassName?: any,
    preventChangeOnBlur?: boolean;
} & React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
>;

const InputSearch = ({ onChangeValue, onKeyDown, placeholder, inputContainerClassName, preventChangeOnBlur, ...props }: Props) => {
    const { t } = useTranslation();
    const [textLength, setTextLength] = useState<number>(0);
    const inputRef = useRef<HTMLInputElement>(null);

    const clearInput = () => {
        setTextLength(0);
        onChangeValue('');
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    }

useEffect(() => {
  if (props.defaultValue !== undefined) {
    const stringValue = Array.isArray(props.defaultValue) ? props.defaultValue.join('') : String(props.defaultValue);
    setTextLength(stringValue.length);    
  }
}, [props.defaultValue]);

    return (
        <div>
            <div className={`${styles.inputContainer} ${inputContainerClassName || ''}`}>
                <input
                    ref={inputRef}
                    type={props.type || 'text'}
                    placeholder={placeholder}
                    {...props}
                    onChange={e => {
                        setTextLength(e.currentTarget.value.length);
                        onChangeValue(e.currentTarget.value);
                    }}
                    onKeyUp={(event: any) => {
                        const keyCode = event.keyCode;
                        if (keyCode === 46 || keyCode === 8) {
                            event.target.value = event.target.value.trim();
                            setTextLength(event.currentTarget.value.length);
                            onChangeValue(event.currentTarget.value);
                        }
                    }}
                    onKeyDown={(e: any) => {
                        if (onKeyDown) {
                            onKeyDown(e);
                        }
                    }}
                    onBlur={event => {
                        if (!preventChangeOnBlur) {
                            event.target.value = event.target.value.trim();
                            setTextLength(event.currentTarget.value.length);
                            onChangeValue(event.currentTarget.value);
                        }
                    }}
                    className={`${styles.inputContent} ${props.className || ''}`}
                />
                {textLength === 0 && <img className={styles.inputImage} src={SearchIcon} style={{ width: '1rem', height: '1rem' }} />}
                {textLength !== 0 && <img className={`${styles.inputImage} ${styles.pointer}`} src={CloseIcon} onClick={clearInput} style={{ width: '1rem', height: '1rem' }} />}
            </div>

            {textLength === props.maxLength && (
                <div>
                    {t('common.field_max_length', { value: textLength })}
                </div>
            )}
        </div>
    );
}

export default memo(InputSearch);
